const imageValidationExtensions = [
  'png',
  'jpg',
  'jpeg',
  'gif',
  'svg',
  'heic',
  'heif',
  'webp',
]

const csvValidationExtension = ['csv', 'xls', 'xlsx']

const mimeTypes: any = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  heic: 'image/heic',
  heif: 'image/heif',
  webp: 'image/webp',
  mp4: 'video/mp4',
  mkv: 'video/x-matroska',
  avi: 'video/x-msvideo',
  mov: 'video/quicktime',
  wmv: 'video/x-ms-wmv',
  flv: 'video/x-flv',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  txt: 'text/plain',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
  rar: 'application/vnd.rar',
}

const videoValidationConfig = {
  videoValidationExtensions: ['mp4', 'mkv', 'avi', 'mov', 'wmv', 'flv'],
  maxVideoSize: 50,
  maxVideoDuration: 300,
}

const genders = [
  {
    name: 'Male',
    value: 'Male',
  },
  {
    name: 'Female',
    value: 'Female',
  },
  {
    name: 'Others',
    value: 'Others',
  },
]

const bloodGroups = [
  {
    name: 'A+',
    value: 'A+',
  },
  {
    name: 'B+',
    value: 'B+',
  },
  {
    name: 'AB+',
    value: 'AB+',
  },
  {
    name: 'O+',
    value: 'O+',
  },
  {
    name: 'AB-',
    value: 'AB-',
  },
  {
    name: 'O-',
    value: 'O-',
  },
  {
    name: 'A-',
    value: 'A-',
  },
  {
    name: 'B-',
    value: 'B-',
  },
]
const weekDays = [
  {
    label: 'Sunday',
  },
  {
    label: 'Monday',
  },
  {
    label: 'Tuesday',
  },
  {
    label: 'Wednesday',
  },
  {
    label: 'Thursday',
  },
  {
    label: 'Friday',
  },
  {
    label: 'Saturday',
  },
]
const slots: any = {
  morning: [
    {
      index: 0,
      startTime: '06:00',
      endTime: '06:30',
      interval: 30,
    },
    {
      index: 1,
      startTime: '06:30',
      endTime: '07:00',
      interval: 30,
    },
    {
      index: 2,
      startTime: '07:00',
      endTime: '07:30',
      interval: 30,
    },
    {
      index: 3,
      startTime: '07:30',
      endTime: '08:00',
      interval: 30,
    },
    {
      index: 4,
      startTime: '08:00',
      endTime: '08:30',
      interval: 30,
    },
    {
      index: 5,
      startTime: '08:30',
      endTime: '09:00',
      interval: 30,
    },
    {
      index: 6,
      startTime: '09:30',
      endTime: '10:00',
      interval: 30,
    },
    {
      index: 7,
      startTime: '10:00',
      endTime: '10:30',
      interval: 30,
    },
    {
      index: 8,
      startTime: '10:30',
      endTime: '11:00',
      interval: 30,
    },
    {
      index: 9,
      startTime: '11:00',
      endTime: '11:30',
      interval: 30,
    },
    {
      index: 10,
      startTime: '11:30',
      endTime: '12:00',
      interval: 30,
    },
  ],
  afternoon: [
    {
      index: 0,
      startTime: '12:00',
      endTime: '12:30',
      interval: 30,
    },
    {
      index: 1,
      startTime: '12:30',
      endTime: '13:00',
      interval: 30,
    },
    {
      index: 2,
      startTime: '01:00',
      endTime: '13:30',
      interval: 30,
    },
    {
      index: 3,
      startTime: '13:30',
      endTime: '14:00',
      interval: 30,
    },
    {
      index: 4,
      startTime: '14:00',
      endTime: '14:30',
      interval: 30,
    },
    {
      index: 5,
      startTime: '14:30',
      endTime: '15:00',
      interval: 30,
    },
    {
      index: 6,
      startTime: '15:00',
      endTime: '15:30',
      interval: 30,
    },
    {
      index: 7,
      startTime: '15:30',
      endTime: '16:00',
      interval: 30,
    },
    {
      index: 8,
      startTime: '16:00',
      endTime: '16:30',
      interval: 30,
    },
    {
      index: 9,
      startTime: '16:30',
      endTime: '17:00',
      interval: 30,
    },
    {
      index: 10,
      startTime: '17:00',
      endTime: '17:30',
      interval: 30,
    },
    {
      index: 11,
      startTime: '17:30',
      endTime: '18:00',
      interval: 30,
    },
  ],
  evening: [
    {
      index: 0,
      startTime: '18:00',
      endTime: '18:30',
      interval: 30,
    },
    {
      index: 1,
      startTime: '18:30',
      endTime: '19:00',
      interval: 30,
    },
    {
      index: 2,
      startTime: '19:00',
      endTime: '19:30',
      interval: 30,
    },
    {
      index: 3,
      startTime: '19:30',
      endTime: '20:00',
      interval: 30,
    },
    {
      index: 4,
      startTime: '20:00',
      endTime: '20:30',
      interval: 30,
    },
    {
      index: 5,
      startTime: '20:30',
      endTime: '21:00',
      interval: 30,
    },
  ],
}

const appointmentTypes = [
  {
    label: 'Online',
    value: 'Online',
  },
  {
    label: 'Clinic',
    value: 'Clinic',
  },
  {
    label: 'Both',
    value: 'Both',
  },
]

const instituteTypes = [
  {
    label: 'Clinic',
    value: 'Clinic',
  },
  {
    label: 'Pharmacy',
    value: 'Pharmacy',
  },
]

const services = [
  {
    label: 'Medical Staff(Doctors)',
    value: 'MedicalStaff',
  },
  {
    label: 'Lab Test',
    value: 'LabTest',
  },
  {
    label: 'Healthcare Services',
    value: 'Healthcare',
  },
  {
    label: 'Medicine',
    value: 'Medicine',
  },
]

const providers = [
  {
    label: 'Medical Staff',
    value: 'Medical Staff',
  },
  {
    label: 'Lab Test',
    value: 'Lab Test',
  },
  {
    label: 'Healthcare Service',
    value: 'Healthcare Service',
  },
  {
    label: 'Medicine',
    value: 'Medicine',
  },
]

const faqCategories = [
  {
    label: 'General',
    value: 'General ',
  },
  {
    label: 'Company',
    value: 'Company',
  },
  {
    label: 'Services',
    value: 'Services',
  },
  {
    label: 'Contact',
    value: 'Contact',
  },
  {
    label: 'Appointment',
    value: 'Appointment',
  },
  {
    label: 'Lab Test',
    value: 'Lab Test',
  },
  {
    label: 'Order Medicine',
    value: 'Order Medicine',
  },
  {
    label: 'Health Care',
    value: 'Health Care',
  },
]

export default {
  imageValidationExtensions,
  csvValidationExtension,
  videoValidationConfig,
  mimeTypes,
  genders,
  bloodGroups,
  weekDays,
  slots,
  appointmentTypes,
  instituteTypes,
  providers,
  services,
  faqCategories,
}
